export const SIDE_BAR_STATUS = 'SIDE_BAR_STATUS';

//  sessionStorage
export const HISTORY_STORAGE_KEY = 'app_navigation_history';
export const ORDER_ADS_DRAFT = 'order_ads_draft';
export const NEW_ORDER_SESSION_STORAGE_KEY = 'new_order';
